export default __webpack_public_path__ + "static/media/qtyandcs.d655b06e.jpg";